import { useTheme } from '@mui/material';
import { formatPhone } from 'app/helpers';
import { capitalize } from 'app/utils/normalizer';
import { Heading4, TextM } from 'app/components';
import {
  ReviewSimulationBox,
  ReviewSimulationPreviewItem,
  ReviewSimulationPreviewItems,
  ReviewStepBox,
} from '../styles';
import { ReviewStepSimulationDivider } from './ReviewStepSimulationDivider';

interface ReviewStepCustodianProps {
  custodian: {
    taxpayer_id?: string;
    foundation_date?: string;
    phone?: {
      number?: string;
    };
    address?: {
      street_name?: string;
      district?: string;
      city?: {
        value?: string;
      };
      postal_code?: string;
      street_number?: string;
      state_code?: {
        value?: string;
      };
      extra_info?: string;
    };
    legal_name?: string;
    email_address?: string;
  } | null;
}

const ReviewStepCustodian = ({ custodian }: ReviewStepCustodianProps) => {
  const theme = useTheme();

  if (!custodian) {
    return null;
  }

  return (
    <ReviewStepBox marginTop="0px" marginBottom="16px">
      <Heading4
        style={{
          color: theme.palette.brand.secondary.base,
        }}
      >
        Custodiante:
      </Heading4>
      <ReviewSimulationBox>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                CNPJ
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.taxpayer_id ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Data de Constituição
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.foundation_date
                  ? new Date(custodian?.foundation_date).toLocaleDateString(
                      'pt-br',
                    )
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Telefone
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.phone?.number
                  ? formatPhone(custodian.phone.number)
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Rua / Avenida
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.street_name
                  ? capitalize(custodian.address.street_name)
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Bairro
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.district
                  ? capitalize(custodian.address.district)
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Cidade
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.city?.value
                  ? capitalize(custodian.address.city.value)
                  : '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
        <ReviewSimulationPreviewItems>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Razão Social
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.legal_name ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                E-mail
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.email_address ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                CEP
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.postal_code ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Número
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.street_number ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Estado
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.state_code?.value ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
          <>
            <ReviewSimulationPreviewItem>
              <TextM
                weight="Semibold"
                style={{ color: theme.palette.brand.secondary.base }}
              >
                Complemento
              </TextM>
              <TextM style={{ color: theme.palette.brand.secondary.base }}>
                {custodian?.address?.extra_info ?? '-'}
              </TextM>
            </ReviewSimulationPreviewItem>
            <ReviewStepSimulationDivider theme={theme} />
          </>
        </ReviewSimulationPreviewItems>
      </ReviewSimulationBox>
    </ReviewStepBox>
  );
};

export default ReviewStepCustodian;
